import * as React from 'react';
import { ApiStationDetails } from '../api/ApiTypes';

type StationDetailContextProps = {
    stationDetails: ApiStationDetails;
    setStationDetails: React.Dispatch<ApiStationDetails>;
};

export const StationDetailContext = React.createContext({} as StationDetailContextProps);
